module.exports = __webpack_public_path__ + "img/startup.b40f0318.png";